module.exports = {"TXTWCL_Repeat_on":{"id":"TXTWCL_Repeat_on","defaultMessage":"Ponovi na sljedeće dane"}}